import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { sans as zoram, lineHeight, fontSize14, fontWeightNormal, fontWeightSemiBold, fontWeightBold } from "@churchofjesuschrist/eden-style-constants";
import shared from "./shared";
import { AppearanceInvert } from "@churchofjesuschrist/eden-appearance";
import { jsx as _jsx } from "react/jsx-runtime";
const Container4 = styled.div.withConfig({
  componentId: "sc-1u44evz-0"
})(["font-family:", ";font-weight:", ";line-height:", ";font-size:", ";", ";& b,& strong{font-weight:", ";}"], zoram, props => props.emphasized ? fontWeightSemiBold : fontWeightNormal, lineHeight, fontSize14, shared, fontWeightBold);
const Text4 = _ref => {
  let {
    children,
    emphasized = false,
    renderAs = "div",
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(AppearanceInvert, {
    inverted: props.inverted,
    children: /*#__PURE__*/_jsx(Container4, {
      emphasized: emphasized,
      as: renderAs,
      ...props,
      children: children
    })
  });
};
Text4.displayName = "Text4";
Text4.propTypes = {
  /** Content */
  children: PropTypes.node.isRequired,
  /** Whether the styles should display as emphasized */
  emphasized: PropTypes.bool,
  /** What html tag or custom react element to render the text as */
  renderAs: PropTypes.elementType,
  /** Whether to apply styles that help the text stand out on a dark background. (deprecated) */
  inverted: PropTypes.bool
};
export default Text4;